


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyC_QcFa04S6_weMHcq-OBov8CiXxPB9hhs",
  authDomain: "pure-vision-seychelles.firebaseapp.com",
  projectId: "pure-vision-seychelles",
  storageBucket: "pure-vision-seychelles.firebasestorage.app",
  messagingSenderId: "226157803658",
  appId: "1:226157803658:web:19135da686f89f999d5573"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export